<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import HomeHeroSection from '../components/landing/HomeHeroSection.vue'
import {
  buildOrganizationJsonLd,
  createJsonLdScript,
} from '../../composables/useStructuredData'

const HomeQaPlatformSection = defineAsyncComponent(() => import('../components/landing/HomeQaPlatformSection.vue'))
const HomeGovernanceSection = defineAsyncComponent(() => import('../components/landing/HomeGovernanceSection.vue'))
const HomeConversionSection = defineAsyncComponent(() => import('../components/landing/HomeConversionSection.vue'))

const PAGE_TITLE = 'QxAIOS | GMP AI Governance Layer for Quality Applications'
const PAGE_DESCRIPTION = 'QxAIOS provides a pre-governed AI operations foundation for GMP environments, while QxAIOPS keeps delivery disciplined, traceable, and audit-aware.'
const CANONICAL_URL = 'https://qx.qiksolve.com/'
const SOCIAL_IMAGE = 'https://qx.qiksolve.com/images/logo.svg'
const ORGANIZATION_NAME = 'QxAIOS'

const { emitSchemaValidationPassed, emitSchemaValidationFailed } = useAnalytics()

const organizationSchema = buildOrganizationJsonLd({
  name: ORGANIZATION_NAME,
  url: CANONICAL_URL,
  logo: SOCIAL_IMAGE,
  description: PAGE_DESCRIPTION,
})

if (organizationSchema.schema) {
  emitSchemaValidationPassed('home', 'organization')
} else {
  emitSchemaValidationFailed('home', 'organization', organizationSchema.reasonCodes)
}

useSeoMeta({
  title: PAGE_TITLE,
  description: PAGE_DESCRIPTION,
  ogTitle: PAGE_TITLE,
  ogDescription: PAGE_DESCRIPTION,
  ogType: 'website',
  ogUrl: CANONICAL_URL,
  ogImage: SOCIAL_IMAGE,
  twitterCard: 'summary_large_image',
  twitterTitle: PAGE_TITLE,
  twitterDescription: PAGE_DESCRIPTION,
  twitterImage: SOCIAL_IMAGE,
  canonical: CANONICAL_URL,
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: CANONICAL_URL,
    },
  ],
  script: organizationSchema.schema ? [createJsonLdScript(organizationSchema.schema)] : [],
})
</script>

<template>
  <div>
    <HomeHeroSection />
    <HomeQaPlatformSection />
    <HomeGovernanceSection />
    <HomeConversionSection />
  </div>
</template>

<style scoped>
section {
  scroll-margin-top: 96px;
}
</style>
